module.exports = __webpack_public_path__ + "media/images/product/f_q-148cb438476ba540fe340b0ac8a307b3.png";